import {Auth0Provider as CoreAuth0Provider} from '@sollapay/web-core';

import {config} from '@/app';

import type {AppState} from '@auth0/auth0-react';
import type {FC, PropsWithChildren} from 'react';

export interface Auth0ProviderProps extends PropsWithChildren {
  onRedirectCallback?: (appState?: AppState) => void;
}

export const Auth0Provider: FC<Auth0ProviderProps> = ({onRedirectCallback, children}) => (
  <CoreAuth0Provider config={config.auth0} onRedirectCallback={onRedirectCallback}>
    {children}
  </CoreAuth0Provider>
);
